import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "./api";
import "../estilo.css";

export default function Cadastro() {
  const location = useLocation();
  const navigate = useNavigate();

  // Dados pessoais
  const [regiao, setRegiao] = useState("BR");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [cpf, setCpf] = useState("");
  const [passwd, setPasswd] = useState("");
  const [passwdConfirm, setPasswdConfirm] = useState("");

  // Robôs e tier
  const [produtos, setProdutos] = useState([]);
  const [pacotes, setPacotes] = useState([]);
  const [selectedRobots, setSelectedRobots] = useState(new Set());
  const [selectedCombo, setSelectedCombo] = useState(false);
  const [selectedTier, setSelectedTier] = useState("starter");

  // Termos e estado
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [showTermos, setShowTermos] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDados, setLoadingDados] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    carregarDados();
  }, []);

  // Receber seleção da página de planos (se vier de lá)
  useEffect(() => {
    if (location.state) {
      const { selectedRobots: robots, selectedCombo: combo, selectedTier: tier } = location.state;
      if (robots && robots.length > 0) setSelectedRobots(new Set(robots));
      if (combo) setSelectedCombo(true);
      if (tier) setSelectedTier(tier);
    }
  }, [location.state]);

  const carregarDados = async () => {
    try {
      const [resProd, resPac] = await Promise.all([
        api.get("/api/produtos-ativos"),
        api.get("/api/pacotes-ativos"),
      ]);
      setProdutos(resProd.data || []);
      setPacotes(resPac.data || []);
    } catch (err) {
      console.error("Erro ao carregar dados:", err);
    } finally {
      setLoadingDados(false);
    }
  };

  const isBrasil = regiao === "BR";

  // Formatadores
  const formatPhone = (num) => {
    if (!num) return "";
    if (num.length <= 2) return `(${num}`;
    if (num.length <= 6) return `(${num.slice(0, 2)}) ${num.slice(2)}`;
    if (num.length <= 10) return `(${num.slice(0, 2)}) ${num.slice(2, 6)}-${num.slice(6)}`;
    return `(${num.slice(0, 2)}) ${num.slice(2, 7)}-${num.slice(7)}`;
  };

  const formatCPF = (n) => {
    if (!n) return "";
    if (n.length <= 3) return n;
    if (n.length <= 6) return `${n.slice(0, 3)}.${n.slice(3)}`;
    if (n.length <= 9) return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6)}`;
    return `${n.slice(0, 3)}.${n.slice(3, 6)}.${n.slice(6, 9)}-${n.slice(9)}`;
  };

  const handlePhone = (value) => {
    if (isBrasil) {
      const clean = value.replace(/\D/g, "").slice(0, 11);
      setPhone(formatPhone(clean));
    } else {
      setPhone(value);
    }
  };

  const handleCpf = (value) => {
    if (isBrasil) {
      const clean = value.replace(/\D/g, "").slice(0, 11);
      setCpf(formatCPF(clean));
    } else {
      setCpf(value);
    }
  };

  const validarEmail = (e) => /\S+@\S+\.\S+/.test(e);

  const validarCPF = (cpfRaw) => {
    const c = cpfRaw.replace(/[^\d]+/g, "");
    if (c.length !== 11) return false;
    if (/^(\d)\1{10}$/.test(c)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(c.charAt(i), 10) * (10 - i);
    let resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(c.charAt(9), 10)) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(c.charAt(i), 10) * (11 - i);
    resto = 11 - (soma % 11);
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(c.charAt(10), 10)) return false;

    return true;
  };

  // Seleção de robôs
  const toggleRobot = (id) => {
    setSelectedCombo(false);
    setSelectedRobots((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const toggleCombo = () => {
    setSelectedCombo(!selectedCombo);
    if (!selectedCombo) setSelectedRobots(new Set());
  };

  // Cálculo do resumo
  const calcResumo = () => {
    const pacote = pacotes[0];
    if (selectedCombo && pacote && pacote.precos[selectedTier]) {
      const p = pacote.precos[selectedTier];
      return { brl: Number(p.valor_brl), usd: Number(p.valor_usd), slots: p.slots_inclusos };
    }
    if (selectedRobots.size > 0) {
      let brl = 0, usd = 0, slots = 0;
      selectedRobots.forEach((id) => {
        const prod = produtos.find((p) => p.id === id);
        if (prod && prod.precos[selectedTier]) {
          brl += Number(prod.precos[selectedTier].valor_brl);
          usd += Number(prod.precos[selectedTier].valor_usd);
          slots = prod.precos[selectedTier].slots_inclusos;
        }
      });
      return { brl, usd, slots };
    }
    return null;
  };

  const resumo = calcResumo();

  // Submit
  const handleCadastro = async () => {
    setMessage("");
    setError(false);

    if (!termosAceitos) {
      setError(true);
      setMessage("Você deve aceitar os Termos de Uso para continuar.");
      return;
    }

    if (!nome || !passwd || !email || !phone || !cpf) {
      setError(true);
      setMessage("Preencha todos os campos obrigatórios.");
      return;
    }

    if (passwd.length < 6) {
      setError(true);
      setMessage("A senha deve ter ao menos 6 caracteres.");
      return;
    }

    if (passwd !== passwdConfirm) {
      setError(true);
      setMessage("As senhas não conferem.");
      return;
    }

    if (!validarEmail(email)) {
      setError(true);
      setMessage("Email inválido.");
      return;
    }

    if (isBrasil) {
      const cleanCPF = cpf.replace(/\D/g, "");
      if (!validarCPF(cleanCPF)) {
        setError(true);
        setMessage("CPF inválido. Verifique o número digitado.");
        return;
      }
    }

    const hasRobots = selectedCombo || selectedRobots.size > 0;
    if (!hasRobots) {
      setError(true);
      setMessage("Selecione pelo menos um robô ou o pacote completo.");
      return;
    }

    setLoading(true);

    const cleanPhone = isBrasil ? phone.replace(/\D/g, "") : phone.trim();
    const cpfParaEnvio = isBrasil ? cpf.replace(/\D/g, "") : cpf.trim();

    const pacote = pacotes[0];
    const body = {
      nome,
      passwd,
      email,
      phone: cleanPhone,
      cpf: cpfParaEnvio,
      tier: selectedTier,
    };

    if (selectedCombo && pacote) {
      body.pacote_id = pacote.id;
    } else {
      body.produtos = Array.from(selectedRobots);
    }

    try {
      const response = await api.post("/cadastro", body);

      setError(false);
      setMessage(
        response.data.message ||
          "Cadastro realizado com sucesso! Entre em contato para ativar sua conta."
      );

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 2500);
    } catch (err) {
      setError(true);
      setMessage(
        err.response?.data?.message || "Erro ao conectar ao servidor."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro-page">
      <div className="cadastro-container">
        <center>
          <img
            src={require("../img/Quantum7.png")}
            width={150}
            height={200}
            alt="Quantum Trades"
          />
        </center>

        <h2 className="cadastro-titulo">Cadastro Quantum Trades</h2>

        {/* Aviso */}
        <div className="cadastro-info-box">
          <p>
            <strong>Importante:</strong> Sua conta é criada inicialmente{" "}
            <strong>desativada</strong>. Após o cadastro, entre em contato com
            nossa equipe (WhatsApp, Telegram ou e-mail) para habilitar o acesso
            e liberar suas licenças.
          </p>
        </div>

        {/* ========== DADOS PESSOAIS ========== */}
        <div className="cadastro-section-label">Seus dados</div>

        <div className="input-container" style={{ textAlign: "center" }}>
          <select
            className="cadastro-input"
            value={regiao}
            onChange={(e) => setRegiao(e.target.value)}
          >
            <option value="BR">Brasil</option>
            <option value="AM_SUL">América do Sul (exceto Brasil)</option>
            <option value="AM_NORTE">América do Norte</option>
            <option value="EUROPA">Europa</option>
            <option value="ASIA">Ásia</option>
            <option value="OUTROS">Outras regiões</option>
          </select>

          <input
            className="cadastro-input"
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Nome completo"
          />

          <input
            className="cadastro-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
          />

          <input
            className="cadastro-input"
            type="text"
            value={phone}
            onChange={(e) => handlePhone(e.target.value)}
            placeholder={
              isBrasil ? "Telefone (com DDD)" : "Telefone (com código do país)"
            }
          />

          <input
            className="cadastro-input"
            type="text"
            value={cpf}
            onChange={(e) => handleCpf(e.target.value)}
            placeholder={
              isBrasil ? "CPF" : "Documento/ID (passaporte, ID nacional, etc.)"
            }
          />

          <input
            className="cadastro-input"
            type="password"
            value={passwd}
            onChange={(e) => setPasswd(e.target.value)}
            placeholder="Senha (mín. 6 caracteres)"
          />

          <input
            className="cadastro-input"
            type="password"
            value={passwdConfirm}
            onChange={(e) => setPasswdConfirm(e.target.value)}
            placeholder="Confirmar senha"
          />
        </div>

        {/* ========== ROBÔS ========== */}
        <div className="cadastro-section-label">Escolha seus robôs</div>

        {loadingDados ? (
          <p style={{ textAlign: "center", color: "#777" }}>Carregando...</p>
        ) : (
          <>
            <div className="cadastro-robots-grid">
              {produtos.map((prod) => (
                <div
                  key={prod.id}
                  className={`cadastro-robot-chip ${
                    selectedRobots.has(prod.id) ? "selected" : ""
                  }`}
                  onClick={() => toggleRobot(prod.id)}
                >
                  <span className="cadastro-robot-check">
                    {selectedRobots.has(prod.id) ? "✓" : ""}
                  </span>
                  <strong>{prod.nome}</strong>
                  <span className="cadastro-robot-desc">{prod.descricao}</span>
                </div>
              ))}
            </div>

            {pacotes[0] && (
              <div
                className={`cadastro-combo-bar ${selectedCombo ? "selected" : ""}`}
                onClick={toggleCombo}
              >
                <strong>{pacotes[0].nome}</strong>
                <span> — {pacotes[0].descricao}</span>
              </div>
            )}
          </>
        )}

        {/* ========== TIER ========== */}
        <div className="cadastro-section-label">Tamanho da operação</div>

        <div className="cadastro-tier-grid">
          {[
            { key: "starter", nome: "Starter", slots: 2 },
            { key: "trader", nome: "Trader", slots: 5 },
            { key: "pro", nome: "Pro", slots: 10 },
          ].map((t) => (
            <div
              key={t.key}
              className={`cadastro-tier-chip ${
                selectedTier === t.key ? "selected" : ""
              }`}
              onClick={() => setSelectedTier(t.key)}
            >
              <strong>{t.nome}</strong>
              <span>{t.slots} contas</span>
            </div>
          ))}
        </div>

        {/* ========== RESUMO ========== */}
        {resumo && (
          <div className="cadastro-resumo">
            <span>
              {selectedCombo
                ? "Pacote completo"
                : `${selectedRobots.size} robô(s)`}{" "}
              × {selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1)}
            </span>
            <strong>
              R$ {resumo.brl.toFixed(2)}/mês
              <span className="cadastro-resumo-usd">
                {" "}(US$ {resumo.usd.toFixed(2)})
              </span>
            </strong>
          </div>
        )}

        {/* ========== TERMOS ========== */}
        <div className="cadastro-termos-centralizado">
          <input
            type="checkbox"
            checked={termosAceitos}
            onChange={(e) => setTermosAceitos(e.target.checked)}
          />
          <label>
            Eu aceito os{" "}
            <button
              type="button"
              className="termos-link-btn"
              onClick={() => setShowTermos(true)}
            >
              Termos de Uso
            </button>
          </label>
        </div>

        <button
          className="cadastro-button"
          onClick={handleCadastro}
          disabled={loading}
        >
          {loading ? "Enviando..." : "Cadastrar"}
        </button>

        {message && (
          <p className={`cadastro-message ${error ? "error" : "success"}`}>
            {message}
          </p>
        )}

        <Link to="/" className="cadastro-link">
          Voltar
        </Link>

        {/* MODAL DOS TERMOS */}
        {showTermos && (
          <div
            className="termos-modal-overlay"
            onClick={() => setShowTermos(false)}
          >
            <div className="termos-modal" onClick={(e) => e.stopPropagation()}>
              <h3>Termos de Uso</h3>
              <div className="termos-text">{TERMO_COMPLETO}</div>
              <button
                className="footer-terms-btn"
                onClick={() => setShowTermos(false)}
              >
                Fechar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const TERMO_COMPLETO = (
  <div>
    <p>
      O usuário ("USUÁRIO"), ao instalar, ativar, utilizar ou realizar qualquer
      operação com o Quantum Trades EA dentro da plataforma MetaTrader 5 (MT5),
      declara estar ciente e de acordo com os seguintes termos:
    </p>
    <p><strong>1 –</strong> O USUÁRIO instala e utiliza o EA por livre vontade, autorizando o tratamento dos dados necessários ao funcionamento, estatísticas, segurança e melhoria contínua.</p>
    <p><strong>2 –</strong> O USUÁRIO compreende plenamente o funcionamento do robô e os riscos financeiros envolvidos em operações automatizadas.</p>
    <p><strong>3 –</strong> Toda configuração de risco, volume, reentradas, metas, stops, correlação entre ativos e demais parâmetros é de responsabilidade exclusiva do USUÁRIO.</p>
    <p><strong>4 –</strong> A Quantum Trades não garante lucros, não presta consultoria financeira, e não se responsabiliza por perdas provenientes de configurações incorretas, slippage, gaps, falhas de conexão, volatilidade extrema ou limitações técnicas do MT5.</p>
    <p><strong>5 –</strong> O EA opera sobre o MetaTrader 5, desenvolvido pela MetaQuotes. Assim, a Quantum Trades não possui responsabilidade por erros ou falhas da plataforma.</p>
    <p><strong>6 –</strong> O USUÁRIO reconhece que o mercado Forex, índices e derivativos envolve risco elevado, podendo resultar em perdas superiores ao capital investido.</p>
    <p><strong>7 –</strong> Demonstrações, backtests e portfólios não garantem resultados futuros.</p>
    <p><strong>8 –</strong> É proibida a distribuição, venda ou compartilhamento do EA sem autorização da Quantum Trades.</p>
    <p><strong>9 –</strong> O EA executa ordens automaticamente seguindo regras definidas pelo USUÁRIO, que assume total responsabilidade pelas decisões configuradas.</p>
    <p><strong>10 –</strong> Eventos extremos, latência, spreads, stop out e gaps podem gerar perdas, e essas perdas são de responsabilidade exclusiva do USUÁRIO.</p>
    <p><strong>11 –</strong> O uso do EA implica aceitação integral destes termos.</p>
    <p><strong>12 – Direito de arrependimento (7 dias):</strong> o USUÁRIO poderá solicitar a devolução integral dos valores pagos pela licença do Quantum Trades EA em até <strong>7 (sete) dias corridos</strong> a contar da data da primeira contratação, caso decida desistir do uso do robô. Após esse prazo, não haverá reembolso, ainda que o EA deixe de ser utilizado.</p>
  </div>
);
